import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Link } from "react-router-dom";
import { getPathWithParam } from "../../utils";
import { faDiamond } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import tenantConfig from "../../mocks/tenantOne.json";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../api-authorization/AuthorizeService";

const ManageCensusMenu = ({ menuList = [], selectedMenu, flow, censusId }) => {
  const [roleName, setRoleName] = useState("VOU");

  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <ul className="manage-company-menu">
      {censusId == undefined
        ? menuList.map((item) => {
            if (item.label == "Employee Information") {
              const childRoutes = get(item, "childRoutes", []);
              let className =
                selectedMenu.indexOf(item.path) !== -1 ||
                childRoutes.filter((route) => {
                  return selectedMenu.indexOf(route) !== -1;
                }).length
                  ? "selected"
                  : "";

              return (
                tenantConfig.employeesSubMenu.includes(item.id) &&
                permissions[roleName].employeesSubMenu[item.id] && (
                  <li
                    key={item.path}
                    className={`${className} has-tick text-wrap`}
                    style={{ padding: "0 2rem" }}
                  >
                    <FontAwesomeIcon icon={faDiamond} size="1x" />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Link
                      to={getPathWithParam({
                        path: item.path,
                        pathParam: [flow, censusId],
                      })}
                    >
                      {item.label}
                    </Link>
                    <span className="open-rounded-corner-top" />
                    <span className="open-rounded-corner-bottom" />
                  </li>
                )
              );
            }
          })
        : menuList.map((item) => {
            const childRoutes = get(item, "childRoutes", []);
            let className =
              selectedMenu.indexOf(item.path) !== -1 ||
              childRoutes.filter((route) => {
                return selectedMenu.indexOf(route) !== -1;
              }).length
                ? "selected"
                : "";

            return (
              tenantConfig.employeesSubMenu.includes(item.id) &&
              permissions[roleName].employeesSubMenu[item.id] && (
                <li key={item.path} className={`${className} has-tick`}>
                  <FontAwesomeIcon icon={faDiamond} size="1x" />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Link
                    to={getPathWithParam({
                      path: item.path,
                      pathParam: [flow, censusId],
                    })}
                  >
                    {item.label}
                  </Link>
                  {/* <span className="open-rounded-corner-top" />
                  <span className="open-rounded-corner-bottom" /> */}
                </li>
              )
            );
            //);
          })}
    </ul>
  );
};

export default ManageCensusMenu;
